// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type QueryDetailsGraphQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  queryId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type QueryDetailsGraphQuery = {
  __typename?: "GraphqlQuery";
  getQueryDetailStats?: {
    __typename?: "QueryStats";
    avgTime?: Array<Array<number | null> | null> | null;
    avgIoTime?: Array<Array<number | null> | null> | null;
    calls?: Array<Array<number | null> | null> | null;
    avgBlksHit?: Array<Array<number | null> | null> | null;
    avgBlksRead?: Array<Array<number | null> | null> | null;
    bytesLoaded?: Array<Array<number | null> | null> | null;
    noData?: Array<Array<number | null> | null> | null;
  } | null;
  getQueryExplainsForGraph: Array<{
    __typename?: "QueryExplain";
    id: string;
    humanId: string;
    time: number;
    querySample?: {
      __typename?: "QuerySample";
      id: string;
      runtimeMs: number;
    } | null;
  }>;
  getServerDetails: {
    __typename?: "Server";
    id: string;
    humanId: string;
    integratedExplain: boolean;
  };
};

export const QueryDetailsGraphDocument = gql`
  query QueryDetailsGraph(
    $databaseId: ID!
    $queryId: ID!
    $startTs: Int!
    $endTs: Int!
  ) {
    getQueryDetailStats(
      databaseId: $databaseId
      queryId: $queryId
      startTs: $startTs
      endTs: $endTs
    ) {
      avgTime
      avgIoTime
      calls
      avgBlksHit
      avgBlksRead
      bytesLoaded
      noData
    }
    getQueryExplainsForGraph(
      databaseId: $databaseId
      queryId: $queryId
      startTs: $startTs
      endTs: $endTs
    ) {
      id
      humanId
      time
      querySample {
        id
        runtimeMs
      }
    }
    getServerDetails(databaseId: $databaseId) {
      id
      humanId
      integratedExplain
    }
  }
`;

/**
 * __useQueryDetailsGraphQuery__
 *
 * To run a query within a React component, call `useQueryDetailsGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryDetailsGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryDetailsGraphQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      queryId: // value for 'queryId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useQueryDetailsGraphQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryDetailsGraphQuery,
    QueryDetailsGraphQueryVariables
  > &
    (
      | { variables: QueryDetailsGraphQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    QueryDetailsGraphQuery,
    QueryDetailsGraphQueryVariables
  >(QueryDetailsGraphDocument, options);
}
export function useQueryDetailsGraphLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryDetailsGraphQuery,
    QueryDetailsGraphQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QueryDetailsGraphQuery,
    QueryDetailsGraphQueryVariables
  >(QueryDetailsGraphDocument, options);
}
// @ts-ignore
export function useQueryDetailsGraphSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryDetailsGraphQuery,
    QueryDetailsGraphQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  QueryDetailsGraphQuery,
  QueryDetailsGraphQueryVariables
>;
export function useQueryDetailsGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryDetailsGraphQuery,
        QueryDetailsGraphQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QueryDetailsGraphQuery | undefined,
  QueryDetailsGraphQueryVariables
>;
export function useQueryDetailsGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryDetailsGraphQuery,
        QueryDetailsGraphQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    QueryDetailsGraphQuery,
    QueryDetailsGraphQueryVariables
  >(QueryDetailsGraphDocument, options);
}
export type QueryDetailsGraphQueryHookResult = ReturnType<
  typeof useQueryDetailsGraphQuery
>;
export type QueryDetailsGraphLazyQueryHookResult = ReturnType<
  typeof useQueryDetailsGraphLazyQuery
>;
export type QueryDetailsGraphSuspenseQueryHookResult = ReturnType<
  typeof useQueryDetailsGraphSuspenseQuery
>;
export type QueryDetailsGraphQueryResult = Apollo.QueryResult<
  QueryDetailsGraphQuery,
  QueryDetailsGraphQueryVariables
>;
